
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-bb7b0566\",\"scoped\":true,\"hasInlineConfig\":false}!scss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./noticeDetail.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./noticeDetail.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bb7b0566\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./noticeDetail.vue"),
  /* scopeId */
  "data-v-bb7b0566",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/views/dashboard/noticeDetail.vue
// module id = 830
// module chunks = 0